document.addEventListener('DOMContentLoaded', () => {
  // 1. Mobil Menü Aç/Kapat
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  // 2. Ürün Görsel Galerisi (Tıklanan görseli aktif yapma)
  const big = document.getElementById('primary-product-image');
  const thumbs = document.querySelectorAll('[data-image]');
  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (big) {
        big.src = btn.dataset.image;
        thumbs.forEach(t => t.style.borderColor = 'var(--line)');
        btn.style.borderColor = '#000';
      }
    });
  });

  // 3. Varyant / Beden & Fiyat Yönetimi (Steelsneakers Hızlı Fiyat Güncellemesi)
  const select = document.getElementById('variant-select');
  const variants = document.getElementById('product-variant-data');
  if (select && variants) {
    try {
      const data = JSON.parse(variants.textContent);
      const money = (cents) => (cents / 100).toLocaleString('tr-TR', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'TRY'
      });

      const updateVariantUI = (variantId) => {
        const variant = data.find((v) => String(v.id) === String(variantId));
        if (!variant) return;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);

        const price = document.getElementById('product-price');
        const compare = document.getElementById('compare-price');
        const addButton = document.querySelector('[data-product-submit]');

        if (price) price.textContent = money(variant.price);
        if (compare) {
          const hasCompare = variant.compare_at_price > variant.price;
          compare.hidden = !hasCompare;
          compare.textContent = hasCompare ? money(variant.compare_at_price) : '';
        }
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'SEPETE EKLE' : 'TÜKENDİ';
        }
      };

      select.addEventListener('change', () => {
        updateVariantUI(select.value);
      });

      // Beden Hapları/Butonları Tıklanırsa
      document.querySelectorAll('[data-variant-id]').forEach(pill => {
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = pill.dataset.variantId;
          select.value = targetId;
          document.querySelectorAll('[data-variant-id]').forEach(p => p.classList.remove('active'));
          pill.classList.add('active');
          updateVariantUI(targetId);
        });
      });

    } catch (error) {
      console.warn('Variant data could not be parsed', error);
    }
  }

  // 4. Sepete Ekle Efekti (Sneaker Dönüşüm Optimizasyonu)
  const productForm = document.querySelector('.product-form form') || document.querySelector('form[action*="/cart/add"]');
  const submitBtn = document.querySelector('[data-product-submit]');
  if (productForm && submitBtn) {
    productForm.addEventListener('submit', () => {
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'SEPETE EKLENİYOR...';
      setTimeout(() => {
        submitBtn.textContent = 'SEPETE EKLENDİ ✓';
        setTimeout(() => {
          submitBtn.textContent = originalText;
        }, 1500);
      }, 400);
    });
  }
});